import { Controller } from "@hotwired/stimulus"
import Rails from "@rails/ujs"

export default class extends Controller {
	static targets = ["copy", "postalCode", "prefectureCd", "city", "streetAddress",
		"extendedAddress", "tel", "email", "staffName", "staffPosition", "clinicPostalCode",
		"clinicPrefectureCd", "clinicCity", "clinicStreetAddress", "clinicExtendedAddress",
		"clinicTel", "clinicEmail", "clinicStaffName", "clinicStaffPosition"]

	copy() {
		if (this.copyTarget.checked) {
			this.clinicPostalCodeTarget.value = this.postalCodeTarget.value
			this.clinicPrefectureCdTarget.value = this.prefectureCdTarget.value
			this.clinicCityTarget.value = this.cityTarget.value
			this.clinicStreetAddressTarget.value = this.streetAddressTarget.value
			this.clinicExtendedAddressTarget.value = this.extendedAddressTarget.value
			this.clinicTelTarget.value = this.telTarget.value
			this.clinicEmailTarget.value = this.emailTarget.value
			this.clinicStaffNameTarget.value = this.staffNameTarget.value
			this.clinicStaffPositionTarget.value = this.staffPositionTarget.value
		} else {
			this.clinicPostalCodeTarget.value = ""
			this.clinicPrefectureCdTarget.value = ""
			this.clinicCityTarget.value = ""
			this.clinicStreetAddressTarget.value = ""
			this.clinicExtendedAddressTarget.value = ""
			this.clinicTelTarget.value = ""
			this.clinicEmailTarget.value = ""
			this.clinicStaffNameTarget.value = ""
			this.clinicStaffPositionTarget.value = ""
		}
	}
}
